import {connectToStores} from 'epic-alt-utils';
import {initBowser} from 'epic-games-nav/dist/client';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import Immutable from 'seamless-immutable';

import AppConfigStore from '../../stores/AppConfigStore';
import HeaderStore from '../../stores/HeaderStore';
import LocalizationStore from '../../stores/LocalizationStore';
import LoginStore from '../../stores/LoginStore';
import MobileStore from '../../stores/MobileStore';

import {NavWrapper} from './NavWrapper';

interface Props extends RouteComponentProps {
  appConfigStore: any;
  loginStore: any;
  localizationStore: any;
  headerStore: any;
  mobileStore: any;
  iosLink: string;
}

/**
 * Wrapper around the NavWrapper to connect to the alt stores and convert the data
 * to regular json.  Then pass the props to a light, functional component of NavWrapper
 */
class NavWrapperAlt extends React.Component<Props> {
  constructor(props) {
    initBowser();
    super(props);
  }

  static getStores() {
    return [AppConfigStore, LocalizationStore, LoginStore, HeaderStore, MobileStore];
  }

  static getPropsFromStores() {
    //hardcoded Apple Store link needed for CTA Button in download.
    const iosMobileLink = 'https://itunes.apple.com/app/fortnite/id1261357853?mt=8';
    const iosLink = MobileStore.getState().mobileData
      ? MobileStore.getState().mobileData.codeConfirm.mobileLink
      : iosMobileLink;

    return {
      iosLink,
      appConfigStore: AppConfigStore.getState(),
      localizationStore: LocalizationStore.getState(),
      loginStore: LoginStore.getState(),
      mobileStore: MobileStore.getState(),
      headerStore: HeaderStore.getState(),
    };
  }

  render() {
    const {
      localizationStore = {},
      headerStore,
      mobileStore = {},
      iosLink,
      history,
      location,
      loginStore,
      appConfigStore = {},
    } = this.props;
    const {accountInfo = {}} = loginStore;
    const {config = {}} = headerStore;

    //The actual NavWrapper and EpicGamesNav may modify the json props. These conversions to mutable
    // and the specific {deep: true} are required.

    console.log('>> navWrapperAlt props', {
      accountInfo,
    });

    return (
      <NavWrapper
        history={history}
        location={location}
        account={Immutable.asMutable(accountInfo)}
        appConfigStore={Immutable.asMutable(appConfigStore)}
        localizationStore={Immutable.asMutable(localizationStore, {deep: true})}
        mobile={{
          iosLink,
          iosEnabled: headerStore.config.iosEnabled,
          android: headerStore.android(),
          ios: headerStore.ios(),
          mobile: headerStore.mobile(),
          tablet: headerStore.tablet(),
          ...Immutable.asMutable(mobileStore),
        }}
        {...Immutable.asMutable(config, {deep: true})}
      />
    );
  }
}

export default connectToStores(withRouter(NavWrapperAlt));
